<script setup lang="ts">
import { RrEmpty } from '@xjlv2/ui'

withDefaults(
  defineProps<{
    title?: string
    description?: string
    compact?: boolean
  }>(),
  {
    title: '暂无数据',
    description: '',
    compact: false
  }
)
</script>

<template>
  <RrEmpty
    :title="title"
    :description="description"
    :compact="compact"
  >
    <template v-if="$slots.icon || $slots.image" #image>
      <slot name="icon"><slot name="image" /></slot>
    </template>
    <template v-if="$slots.default" #default>
      <slot />
    </template>
    <template v-if="$slots.actions" #actions>
      <slot name="actions" />
    </template>
  </RrEmpty>
</template>
